var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocioambiental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "socioambiental",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.319,
    height: 75.338,
    viewBox: "0 0 75.319 75.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M50.853,19.165A28.874,28.874,0,0,1,54.23,25.5a1.256,1.256,0,1,0,2.346-.9A31.373,31.373,0,0,0,52.9,17.717a1.256,1.256,0,1,0-2.052,1.448Z",
    transform: "translate(10.426 1.883)",
    fill: "#7d0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M43.564,11.049a1.254,1.254,0,0,0,.426,1.723,28.985,28.985,0,0,1,5.637,4.442,1.256,1.256,0,1,0,1.786-1.766,31.514,31.514,0,0,0-6.126-4.825,1.252,1.252,0,0,0-1.723.426Z",
    transform: "translate(8.576 0.159)",
    fill: "#7d0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M54.983,37.152a28.622,28.622,0,0,1-2.4,6.76,1.256,1.256,0,1,0,2.243,1.131,31.177,31.177,0,0,0,2.61-7.353,1.256,1.256,0,1,0-2.454-.537Z",
    transform: "translate(10.893 6.733)",
    fill: "#7d0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M54.558,27.772a29.187,29.187,0,0,1,.525,7.159,1.255,1.255,0,1,0,2.508.125,31.648,31.648,0,0,0-.571-7.777,1.256,1.256,0,1,0-2.462.493Z",
    transform: "translate(11.425 4.204)",
    fill: "#7d0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M10.068,38.244a29.14,29.14,0,0,1-.519-7.16,1.255,1.255,0,1,0-2.508-.129,31.607,31.607,0,0,0,.564,7.779,1.256,1.256,0,1,0,2.463-.491Z",
    transform: "translate(-0.723 5.097)",
    fill: "#7d0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M10.993,40.349a1.256,1.256,0,1,0-2.347.894,31.351,31.351,0,0,0,3.666,6.887,1.255,1.255,0,1,0,2.053-1.446,28.854,28.854,0,0,1-3.372-6.336Z",
    transform: "translate(-0.323 7.596)",
    fill: "#7d0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M10.217,20.889a31.15,31.15,0,0,0-2.625,7.349,1.256,1.256,0,0,0,2.452.542,28.667,28.667,0,0,1,2.413-6.757,1.256,1.256,0,1,0-2.24-1.134Z",
    transform: "translate(-0.579 2.653)",
    fill: "#7d0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M21.705,52.682a29.08,29.08,0,0,1-5.635-4.447A1.256,1.256,0,1,0,14.283,50c2.028,1.871,4.174,4.053,6.771,5.013a1.263,1.263,0,0,0,.651-2.33Z",
    transform: "translate(1.046 9.723)",
    fill: "#7d0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M67.711,40.418a3.788,3.788,0,0,0-3.3,2.055c-1.543,2.867-5.668,5.384-9.715,7.278a3.412,3.412,0,0,0-3.259-5.568l-9.979,2.138a7.126,7.126,0,0,0-4.9,3.8l-1.082,2.164L28.181,54.6a3.744,3.744,0,0,0-2.515,2.677l-1.392,5.564a3.766,3.766,0,0,0,3.654,4.681h9.725a1.285,1.285,0,0,0,1.256-1.457c22.156-3.093,29.854-14.024,32.471-20.337a3.869,3.869,0,0,0-3.668-5.305ZM27.927,65.007a1.262,1.262,0,0,1-1.218-1.56L28.1,57.883a1.263,1.263,0,0,1,.838-.893l6.339-2.01,1.114,10.026ZM69.059,44.762c-2.4,5.8-9.525,15.839-30.3,18.792l-1.111-10c.947-1.965,1.9-4.372,4.338-4.773l9.979-2.138a.878.878,0,0,1,.856,1.443,18.371,18.371,0,0,1-7.8,5.342,1.256,1.256,0,0,0,.744,2.4c.691-.2,16.975-4.944,20.858-12.158a1.34,1.34,0,0,1,2.438,1.1Z",
    transform: "translate(3.663 7.82)",
    fill: "#7d0000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M9.26,27.043c1.543-2.867,5.668-5.384,9.715-7.278a3.412,3.412,0,0,0,3.259,5.568l9.979-2.138a7.126,7.126,0,0,0,4.9-3.8L38.2,17.232,46.826,14.5a1.255,1.255,0,0,0,.839-.892L50.178,3.559A1.264,1.264,0,0,0,48.96,2H36.019a1.285,1.285,0,0,0-1.256,1.457C12.607,6.548,4.909,17.479,2.292,23.793a3.814,3.814,0,0,0,.355,3.586,3.874,3.874,0,0,0,6.613-.335ZM47.352,4.51l-1.953,7.8-7.007,2.222L37.278,4.51ZM5.862,26.587a1.342,1.342,0,0,1-1.25-1.832c2.4-5.8,9.525-15.839,30.3-18.792l1.111,10c-.945,1.963-1.9,4.373-4.338,4.773l-9.979,2.139a.878.878,0,0,1-.856-1.443,18.371,18.371,0,0,1,7.8-5.342,1.255,1.255,0,1,0-.744-2.4c-.691.2-16.975,4.944-20.858,12.159a1.3,1.3,0,0,1-1.188.734Z",
    transform: "translate(-2 -1.999)",
    fill: "#7d0000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M44.972,33.611a11.226,11.226,0,0,0-4.193-7.565c-4.6-3.656-18.354-2.691-19.907-2.569a1.263,1.263,0,0,0-1.143,1.438c.23,1.541,2.385,15.164,6.981,18.819a11.314,11.314,0,0,0,15.04-.872l3.987,3.172A1.256,1.256,0,1,0,47.3,44.068L43.312,40.9a11.209,11.209,0,0,0,1.66-7.285ZM24.987,35.938l6.5-1.24,3.244,2.581L26.218,38.9a26.97,26.97,0,0,1-1.231-2.965ZM22.8,27.786l6.1,4.85-4.683.894c-.583-1.982-1.059-4.009-1.413-5.743Zm10.252,4.946-.253-6.61a26.954,26.954,0,0,1,3.166.533l.331,8.658Zm-2.775-6.826.182,4.764-6.1-4.849c1.769-.044,3.852-.037,5.913.085Zm-2,15.863a4.773,4.773,0,0,1-.6-.587l9.648-1.841,2.441,1.941a8.8,8.8,0,0,1-11.489.487Zm10.612-4.394-.376-9.814a8.72,8.72,0,0,1,2.818,11.757Z",
    transform: "translate(2.527 3.439)",
    fill: "#7d0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocioambiental);
export default __webpack_public_path__ + "static/media/socioambiental.9fd7ecb24d970e5a50655768fa47c8eb.svg";
export { ForwardRef as ReactComponent };